import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mail, Phone, ArrowUpRight } from 'lucide-react';
import { companyInfo, navLinks } from '../data/mock';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-2"
          >
            <div className="mb-6">
              <Logo size="default" />
            </div>
            <p className="body-small mb-4" style={{ color: 'var(--text-muted)' }}>
              {companyInfo.tagline}
            </p>
            <p
              className="caption"
              style={{ color: 'var(--accent-primary)' }}
            >
              Artificial intelligence, guided by strategy.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="caption mb-6" style={{ color: 'var(--text-primary)' }}>Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="body-small flex items-center gap-1 group"
                >
                  {link.label}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
            </nav>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="caption mb-6" style={{ color: 'var(--text-primary)' }}>Contact</h4>
            <div className="space-y-4">
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-start gap-3 body-small group"
              >
                <Mail size={16} className="mt-0.5 flex-shrink-0" style={{ color: 'var(--accent-primary)' }} />
                <span>{companyInfo.email}</span>
              </a>
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-start gap-3 body-small group"
              >
                <Phone size={16} className="mt-0.5 flex-shrink-0" style={{ color: 'var(--accent-primary)' }} />
                <span>{companyInfo.phone}</span>
              </a>
              <div className="flex items-start gap-3 body-small">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" style={{ color: 'var(--accent-primary)' }} />
                <span style={{ color: 'var(--text-muted)' }}>{companyInfo.address}</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid var(--border-primary)' }}
        >
          <p className="body-small" style={{ color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <p className="body-small" style={{ color: 'var(--text-muted)' }}>
            Registered in England & Wales
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
